module.exports = __webpack_public_path__ + "img/ismeretlen.83d9ddb3.jpg";